const LAY_DANH_SACH_VAN_BAN_THANH_CONG = (state, danhSachVanBan) => {
  state.danhSachVanBan = danhSachVanBan;
};

const TAO_VAN_BAN_THANH_CONG = (state, vanBan) => {
  state.danhSachVanBan.push(
    Object.assign({}, vanBan, { id: state.vanBanId + 1 })
  );
};

const CAP_NHAT_VAN_BAN_THANH_CONG = (state, vanBan) => {
  const editItemIndex = state.danhSachVanBan.findIndex(
    (obj) => obj.id === parseInt(vanBan.id)
  );
  state.danhSachVanBan[editItemIndex] = vanBan;
};

const XOA_VAN_BAN_THANH_CONG = (state, vanBan) => {
  state.danhSachVanBan.splice(state.danhSachVanBan.indexOf(vanBan), 1);
};

const TANG_ID_VAN_BAN = (state) => {
  state.vanBanId++;
};

const LAY_CHI_TIET_VAN_BAN_THANH_CONG = (state, vanBanId) => {
  const editItemIndex = state.danhSachVanBan.findIndex(
    (obj) => obj.id === parseInt(vanBanId)
  );

  state.vanBanDangCapNhat = state.danhSachVanBan[editItemIndex];
};

const SET_DANH_SACH_LOAI_SO_VAN_BAN = (state, danhSachLoaiSoVanBan) => {
  state.danhSachLoaiSoVanBan = danhSachLoaiSoVanBan;
};

const SET_DANH_SACH_SO_VAN_BAN = (state, danhSachSoVanBan) => {
  state.danhSachSoVanBan = danhSachSoVanBan;
};

const SET_SAO_CHEP_VAN_BAN = (state, saoChepVanBan) => {
  state.saoChepVanBan = saoChepVanBan;
};

const SET_DANH_SACH_LOAI_VAN_BAN_PAGING = (state, danhSachLoaiVanBanPaging) => {
  state.danhSachLoaiVanBanPaging = danhSachLoaiVanBanPaging;
};

const SET_DANH_SACH_LOAI_VAN_BAN_MAC_DINH = (state, danhSachLoaiVanBanMacDinh) => {
  state.danhSachLoaiVanBanMacDinh = danhSachLoaiVanBanMacDinh;
}

const SET_INFO_SODEN = (state, payload) => {
  state.infoSoDen = payload;
}

const SET_INFO_SOPHU = (state, payload) => {
  state.infoSoPhu = payload;
}

export default {
  LAY_DANH_SACH_VAN_BAN_THANH_CONG,
  TAO_VAN_BAN_THANH_CONG,
  CAP_NHAT_VAN_BAN_THANH_CONG,
  XOA_VAN_BAN_THANH_CONG,
  TANG_ID_VAN_BAN,
  LAY_CHI_TIET_VAN_BAN_THANH_CONG,
  SET_DANH_SACH_LOAI_SO_VAN_BAN,
  SET_DANH_SACH_SO_VAN_BAN,
  SET_SAO_CHEP_VAN_BAN,
  SET_DANH_SACH_LOAI_VAN_BAN_PAGING,
  SET_DANH_SACH_LOAI_VAN_BAN_MAC_DINH,
  SET_INFO_SODEN,
  SET_INFO_SOPHU
};
